import { RootState } from "../redux/store";

export const determineIsUserEndUser = (id: string, state: RootState) => {
    const rolesArray: any = (state.account.users.find((user) => user.id === id)?.roles)?.split(',')
    const isEndUser = (currentValue: string) => currentValue === 'End User';
    return rolesArray?.every(isEndUser)
}